import { Skeleton } from 'antd';

export const CardDetailSkeleton = () => {
  return (
    <div>
      {/* En-tête */}
      <Skeleton.Input active size="large" className="!w-[300px] !mb-6" />

      {/* Carte principale */}
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="flex flex-col lg:grid lg:grid-cols-2 lg:gap-8">
          {/* Section Image */}
          <div className="relative min-h-[400px] sm:min-h-[500px] md:min-h-[600px] lg:min-h-0 lg:h-auto p-4 sm:p-6 md:p-8 flex items-center justify-center bg-gray-50">
            <Skeleton.Image active className="!w-full !h-[500px]" />
          </div>

          {/* Section Détails */}
          <div className="p-4 sm:p-6 md:p-8 lg:p-10">
            <div className="space-y-6 sm:space-y-8">
              {/* En-tête */}
              <div>
                <Skeleton.Input active size="large" className="!w-[70%] !mb-4" />
                <div className="flex flex-wrap items-center gap-2 sm:gap-4">
                  <Skeleton.Button active size="small" className="!w-[100px]" />
                  <Skeleton.Input active size="small" className="!w-[80px]" />
                </div>
              </div>

              {/* Informations Principales */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                {/* Info Cards */}
                {[...Array(2)].map((_, index) => (
                  <div key={index} className="bg-gray-50 rounded-xl p-4 h-40">
                    <div className="flex items-center gap-2 mb-2">
                      <Skeleton.Avatar active size="small" shape="square" />
                      <Skeleton.Input active size="small" className="!w-[80px]" />
                    </div>
                    <div className="flex items-center justify-center h-[calc(100%-32px)]">
                      <Skeleton.Image active className="!w-20 !h-20" />
                    </div>
                  </div>
                ))}
              </div>

              {/* Section Collection */}
              <div className="pt-4 border-t border-gray-200">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                  <Skeleton.Input active size="small" className="!w-[200px]" />
                  <div className="flex items-center gap-4">
                    <Skeleton.Button active size="large" className="!w-[40px] !h-[40px]" />
                    <Skeleton.Input active size="large" className="!w-[60px]" />
                    <Skeleton.Button active size="large" className="!w-[40px] !h-[40px]" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section Cartes Similaires */}
      <div className="mt-8">
        <div className="bg-white rounded-2xl shadow-md p-8 border border-indigo-100">
          <div className="flex items-center justify-between mb-6">
            <Skeleton.Input active size="large" className="!w-[200px]" />
            <Skeleton.Input active size="small" className="!w-[100px]" />
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-2">
                <Skeleton.Image active className="!w-full !aspect-[3/4]" />
                <div className="mt-2">
                  <Skeleton.Input active size="small" className="!w-full" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}; 